export default __webpack_public_path__ + "9f70fbeda03368dd4841dac3f1db3852.jpg";